import { render, staticRenderFns } from "./AdminClientesComponent.vue?vue&type=template&id=be2035dc"
import script from "./AdminClientesComponent.vue?vue&type=script&lang=ts"
export * from "./AdminClientesComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports